/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import LoanCalculatorInfo from "./loan-calculator-info";
import LoanCalculator from "./loan-calculator";
import PropTypes from "prop-types";
const LoanCalculatorRevamp = (props) => {
    const {calculatorRef} = props;
    return (
        <div ref={calculatorRef} styleName={"styles.outer"}>
            <LoanCalculatorInfo {...props} />
            <LoanCalculator {...props} />
        </div>
    );
};

LoanCalculatorRevamp.propTypes = {
    calculatorRef: PropTypes.object
};

export default LoanCalculatorRevamp;
